const ProjectClient = ({ clientName }: { clientName: string }) => {
  return (
    <div className="text-base text-blank-yellow-tint-70 mb-16 group-hover:text-blank-yellow transition-colors duration-1000 ease-spring will-change-colors">
      {clientName}
    </div>
  );
};

export default ProjectClient;
